import type { CreateClientConfig } from "Infrastructure/Api/generated/client.gen";

export const createClientConfig: CreateClientConfig = (config) => ({
	...config,
	baseUrl: import.meta.env.VITE_API_URL,
	throwOnError: true,
});
